var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiple-filters-container"},_vm._l((_vm.filters),function(filter,index){return _c(filter.component,_vm._b({key:index,tag:"component"},'component',filter.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }